import _objectSpread from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
import _wrapNativeSuper from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper";
import { equalColorObjects } from '../utils/compare.js';
import { fire, tpl } from '../utils/dom.js';
import { Hue } from './hue.js';
import { Saturation } from './saturation.js';
import css from '../styles/color-picker.js';
import hueCss from '../styles/hue.js';
import saturationCss from '../styles/saturation.js';
var $isSame = Symbol('same');
var $color = Symbol('color');
var $hsva = Symbol('hsva');
var $update = Symbol('update');
var $parts = Symbol('parts');
export var $css = Symbol('css');
export var $sliders = Symbol('sliders');
export var ColorPicker = /*#__PURE__*/function (_HTMLElement) {
  _inherits(ColorPicker, _HTMLElement);
  var _super = _createSuper(ColorPicker);
  function ColorPicker() {
    var _this;
    _classCallCheck(this, ColorPicker);
    _this = _super.call(this);
    var template = tpl("<style>".concat(_this[$css].join(''), "</style>"));
    var root = _this.attachShadow({
      mode: 'open'
    });
    root.appendChild(template.content.cloneNode(true));
    root.addEventListener('move', _assertThisInitialized(_this));
    _this[$parts] = _this[$sliders].map(function (slider) {
      return new slider(root);
    });
    return _this;
  }
  _createClass(ColorPicker, [{
    key: $css,
    get: function get() {
      return [css, hueCss, saturationCss];
    }
  }, {
    key: $sliders,
    get: function get() {
      return [Saturation, Hue];
    }
  }, {
    key: "color",
    get: function get() {
      return this[$color];
    }
  }, {
    key: "color",
    set: function set(newColor) {
      if (!this[$isSame](newColor)) {
        var newHsva = this.colorModel.toHsva(newColor);
        this[$update](newHsva);
        this[$color] = newColor;
      }
    }
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      // A user may set a property on an _instance_ of an element,
      // before its prototype has been connected to this class.
      // If so, we need to run it through the proper class setter.
      if (this.hasOwnProperty('color')) {
        var value = this.color;
        delete this['color'];
        this.color = value;
      } else if (!this.color) {
        this.color = this.colorModel.defaultColor;
      }
    }
  }, {
    key: "attributeChangedCallback",
    value: function attributeChangedCallback(_attr, _oldVal, newVal) {
      var color = this.colorModel.fromAttr(newVal);
      if (!this[$isSame](color)) {
        this.color = color;
      }
    }
  }, {
    key: "handleEvent",
    value: function handleEvent(event) {
      // Merge the current HSV color object with updated params.
      var oldHsva = this[$hsva];
      var newHsva = _objectSpread(_objectSpread({}, oldHsva), event.detail);
      this[$update](newHsva);
      var newColor;
      if (!equalColorObjects(newHsva, oldHsva) && !this[$isSame](newColor = this.colorModel.fromHsva(newHsva))) {
        this[$color] = newColor;
        fire(this, 'color-changed', {
          value: newColor
        });
      }
    }
  }, {
    key: $isSame,
    value: function value(color) {
      return this.color && this.colorModel.equal(color, this.color);
    }
  }, {
    key: $update,
    value: function value(hsva) {
      this[$hsva] = hsva;
      this[$parts].forEach(function (part) {
        return part.update(hsva);
      });
    }
  }], [{
    key: "observedAttributes",
    get: function get() {
      return ['color'];
    }
  }]);
  return ColorPicker;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));